import {FaInstagram, FaYoutube} from "react-icons/fa";
import {useTranslation} from "react-i18next";

const Footer = () => {
	const {t} = useTranslation();
	return (
		<div className="footer">
			<div className="px__Screen">
				<div
					className="main__content display_v1"
					id="main__content__v1"
					style={{
						borderTop: "1px solid rgba(198, 198, 198, 1)",
					}}
				>
					<div
						className="item2"
						style={{
							position: "relative",
						}}
					>
						<div
							className=" tc__content_v2"
							style={{
								textAlign: "left",
							}}
						>
              <span
	              style={{
		              fontSize: "25px",
		              fontWeight: "bold",
	              }}
              >
                SPETTRUM
              </span>{" "}
							<span
								style={{
									fontSize: "15px",
									fontWeight: "lighter",
								}}
							>
                {t("footer__content_1")}
              </span>
							<br/>
							<a
								href="https://www.instagram.com/spettrum.official/"
								target="_blank"
								rel="noopener noreferrer"
								style={{color: "black"}}
							>
								<FaInstagram size="30"/>
							</a>
							<span style={{paddingLeft: "10px"}}>
                <a
	                href="https://www.youtube.com/@Spettrum"
	                target="_blank"
	                rel="noopener noreferrer"
	                style={{color: "black"}}
                >
                  <FaYoutube size="30"/>
                </a>
              </span>
						</div>
					</div>

					<div
						className="item4"
						style={{
							textAlign: "center",
						}}
					>
						<div
							className=" tc__content_v2"
							style={{
								textAlign: "left",
							}}
						>
              <span
	              style={{
		              fontSize: "14px",
		              fontWeight: "lighter",
	              }}
              >
                <span
	                style={{
		                fontWeight: "bold",
		                color: "rgb(80,80,80)",
	                }}
                >
                  {t("footer__content_2")}
                </span>{" "}
	              {t("footer__content_3")}
	              <br/>
                <span
	                style={{
		                fontWeight: "bold",
		                color: "rgb(80,80,80)",
	                }}
                >
                  {t("footer__content_4")}
                </span>
	              {t("footer__content_5")}
	              <span
		              style={{
			              fontWeight: "bold",
			              color: "rgb(80,80,80)",
		              }}
	              >
                  {t("footer__content_6")}
                </span>
	              {t("footer__content_7")}
	              <br/>
                <span
	                style={{
		                fontWeight: "bold",
		                color: "rgb(80,80,80)",
	                }}
                >
                  {t("footer__content_8")}
                </span>
	              {t("footer__content_9")}
	              <span
		              style={{
			              fontWeight: "bold",
			              color: "rgb(80,80,80)",
		              }}
	              >
                  {t("footer__content_10")}
                </span>{" "}
	              {t("footer__content_11")}
	              <br/>
	              <span>
                      <a
	                      href="/policy.html"
	                      target="_blank"
	                      rel="noopener noreferrer"
	                      style={{textDecoration: "none", color: "inherit"}}
                      >
                        {t("footer__content_12")}
                      </a>
                  </span>{" "}
	              |{" "}
	              <a
		              href="/policy.html"
		              target="_blank"
		              rel="noopener noreferrer"
		              style={{textDecoration: "none", color: "inherit"}}
	              >
                      {t("footer__content_13")}
                  </a>
              </span>
						</div>
					</div>
				</div>

				<div
					className="main__content display_v2"
					id="main__content__v1"
					style={{
						borderTop: "1px solid rgba(198, 198, 198, 1)",
					}}
				>
					<div
						className="item2"
						style={{
							position: "relative",
						}}
					>
						<div className="footer__content">
							<div
								className=" tc__content_v2"
								style={{
									textAlign: "left",
								}}
							>
                <span
	                style={{
		                fontSize: "15px",
		                fontWeight: "bold",
	                }}
                >
                  SPETTRUM
                </span>{" "}
								<span
									style={{
										fontSize: "10px",
										fontWeight: "lighter",
									}}
								>
                  {t("footer__content_1")}
                </span>
								<br/>
							</div>
						</div>
					</div>

					<div
						className="item4"
						style={{
							textAlign: "center",
						}}
					>
						<div className="footer__content">
							<div
								className=" tc__content_v2"
								style={{
									textAlign: "left",
								}}
							>
                <span
	                style={{
		                fontSize: "9px",
		                fontWeight: "lighter",
	                }}
                >
                  <strong>{t("footer__content_2")}</strong>
                  <br/> {t("footer__content_3")}
	                <br/>
                  <strong>{t("footer__content_4")}</strong>{" "}
	                {t("footer__content_5")}
	                <strong>{t("footer__content_6")}</strong>{" "}
	                {t("footer__content_7")}
	                <br/>
                  <strong>{t("footer__content_8")}</strong>{" "}
	                {t("footer__content_9")}
	                <strong>{t("footer__content_10")}</strong>{" "}
	                {t("footer__content_11")}
                </span>
								<div
									className="imog"
									style={{
										paddingTop: "20px",
										textAlign: "left",
									}}
								>
									<FaInstagram size="30"/>
									<span style={{paddingLeft: "10px"}}>
                    <FaYoutube size="30"/>
                  </span>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div
					className="main__content"
					id="main__content__v2"
					style={{marginTop: "0"}}
				>
					<div
						className="item3"
						style={{
							// paddingLeft: "100px",
							textAlign: "center",
							paddingTop: "0",
						}}
					>
						<div className="text__content">
              <span
	              style={{
		              fontSize: "10px",
		              fontWeight: "bold",
	              }}
              >
                2024 SPETTRUM / All Rights Reserved
              </span>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Footer;
